export default __webpack_public_path__ + "static/media/Handbuch-Piktogramm.33413958.svg";